import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '@/context/ThemeContext';

// min-h/min-w in px: rem padding alone drops below CLAUDE.md's 44px floor at a 14px root font.
const buttonClass =
  'inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-gray-700 transition-colors hover:bg-primary/10 hover:text-primary-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-dark active:scale-95 dark:text-gray-300 dark:hover:text-primary dark:focus-visible:ring-primary';

const ThemeToggle = (): JSX.Element => {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';
    const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

    return (
        <button
            type="button"
            onClick={toggleTheme}
            aria-label={label}
            title={label}
            className={buttonClass}
        >
            {isDark ? <SunIcon className="h-6 w-6" /> : <MoonIcon className="h-6 w-6" />}
        </button>
    );
};

export default ThemeToggle;
